import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppMainComponent } from './app.main.component';
import { AccountService } from '../services/account.service';
import { SettingsService } from '../services/settings.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './app-topbar.component.html',
  styles: [
    `
      .layout-dark .dark-switch {
        display: none;
      }
      .layout-light .light-switch {
        display: none;
      }
      .dark-switch {
        color: #00000;
      }
      .light-switch {
        color: #ffffff;
      }
      .light-switch,
      .dark-switch {
        font-size: 20px;
        padding: 4px 10px 0 10px;
      }
    `,
  ],
})
export class AppTopBarComponent {
  activeItem: number;
  nom: string = '';
  photo: string = null;
  isAuthentificated = false;

  constructor(
    public app: AppMainComponent,
    private router: Router,
    private accountService: AccountService,
    public settingsService: SettingsService,
  ) {}

  mobileMegaMenuItemClick(index) {
    this.app.megaMenuMobileClick = true;
    this.activeItem = this.activeItem === index ? null : index;
  }

  ngOnInit() {
    this.getUtilisateurInfo();
    this.accountService.isLogged.subscribe(isLogged => {
      this.isAuthentificated = isLogged;
      this.getUtilisateurInfo();
    });
  }

  getUtilisateurInfo() {
    let user = this.accountService.getUtilisateurAngular();
    if (user) {
      this.nom = user.NomToDisplay;
      this.photo = user.PhotoUrl;
      this.isAuthentificated = true;
    } else {
      this.nom = '';
      this.photo = null;
      setTimeout(() => {
        this.getUtilisateurInfo();
      }, 1000);
    }
  }

  logout() {
    this.accountService.logout();
    this.getUtilisateurInfo();
    this.router.navigate(['/login']);
  }

  changeLayout(event, isDark: boolean) {
    this.settingsService.SiteIsDark = isDark;
    this.app.changeLayout();
    event.preventDefault();
  }
}
